import he from './he';
import ar from './ar';

export type Lang = 'he' | 'ar';

const translations: Record<Lang, Record<string, any>> = { he, ar };

export function t(key: string, lang: Lang): string {
  const keys = key.split('.');
  let val: any = translations[lang];
  for (const k of keys) {
    if (val && typeof val === 'object') {
      val = val[k];
    } else {
      return key;
    }
  }
  return typeof val === 'string' ? val : key;
}

export default translations;
